<eventq-dialog-popover
  [open]="open()"
  title="Report Camera"
  [cancelLabel]="cancelLabel()"
  [confirmLabel]="confirmLabel()"
  [confirmDisabled]="confirmDisabled()"
  [anchor]="anchor()"
  [placement]="resolvedPlacement()"
  [panelWidth]="panelWidth()"
  (closed)="closed.emit()"
  (confirmed)="onConfirm()"
>
  <div class="flag-report-popover__options" role="listbox" aria-label="Report reason">
    @for (option of reasonOptions(); track option.id) {
      <button
        type="button"
        class="flag-report-popover__option"
        role="option"
        [class.flag-report-popover__option--selected]="option.id === selectedReasonId()"
        [attr.aria-selected]="option.id === selectedReasonId()"
        (click)="onSelect(option.id)"
      >
        <span class="flag-report-popover__option-icon" aria-hidden="true">
          <img [src]="option.iconSrc | prefixUrl" alt="" />
        </span>
        <span class="flag-report-popover__option-label">{{ option.label }}</span>
      </button>
    }
  </div>
</eventq-dialog-popover>
